// Vendor definitions database
export const VENDORS = {
    // General Goods Vendor
    general_merchant: {
        id: 'general_merchant',
        name: 'Marcus the Merchant',
        title: 'General Goods',
        icon: '🧔',
        greeting: 'Welcome, traveler! Browse my wares.',
        farewell: 'Safe travels, friend!',
        buybackSlots: 12,
        repairEnabled: false,
        inventory: [
            { itemId: 'health_potion', stock: -1, buyPrice: 10 },
            { itemId: 'mana_potion', stock: -1, buyPrice: 10 },
            { itemId: 'greater_health_potion', stock: 10, buyPrice: 50 },
            { itemId: 'bandage', stock: -1, buyPrice: 5 },
        ],
    },
    // Weaponsmith
    weaponsmith: {
        id: 'weaponsmith',
        name: 'Grimhammer',
        title: 'Master Weaponsmith',
        icon: '⚒️',
        greeting: 'Need a blade? I forge the finest steel in the realm!',
        farewell: 'May your blade strike true!',
        buybackSlots: 12,
        repairEnabled: true,
        inventory: [
            { itemId: 'rusty_sword', stock: 5, buyPrice: 25 },
            { itemId: 'rusty_dagger', stock: 5, buyPrice: 20 },
            { itemId: 'crude_axe', stock: 3, buyPrice: 35 },
            { itemId: 'iron_sword', stock: 2, buyPrice: 150 },
            { itemId: 'apprentice_staff', stock: 3, buyPrice: 40 },
            { itemId: 'wooden_staff', stock: 5, buyPrice: 25 },
        ],
    },
    // Armorsmith
    armorsmith: {
        id: 'armorsmith',
        name: 'Helga Ironweave',
        title: 'Armorer',
        icon: '🛡️',
        greeting: 'Protection is paramount! See what I have for you.',
        farewell: 'Stay protected out there!',
        buybackSlots: 12,
        repairEnabled: true,
        inventory: [
            { itemId: 'leather_vest', stock: 5, buyPrice: 40 },
            { itemId: 'leather_jerkin', stock: 3, buyPrice: 35 },
            { itemId: 'cloth_robe', stock: 5, buyPrice: 30 },
            { itemId: 'novice_robe', stock: 3, buyPrice: 35 },
        ],
    },
    // Alchemist
    alchemist: {
        id: 'alchemist',
        name: 'Elara Mistweaver',
        title: 'Alchemist',
        icon: '🧪',
        greeting: 'Potions, elixirs, and more! What do you need?',
        farewell: 'May my brews serve you well!',
        buybackSlots: 12,
        repairEnabled: false,
        inventory: [
            { itemId: 'health_potion', stock: -1, buyPrice: 8 },
            { itemId: 'mana_potion', stock: -1, buyPrice: 8 },
            { itemId: 'greater_health_potion', stock: 20, buyPrice: 40 },
        ],
    },
    // Materials Trader
    materials_trader: {
        id: 'materials_trader',
        name: 'Old Tom',
        title: 'Materials Trader',
        icon: '📦',
        greeting: 'I buy and sell crafting materials. What do you have?',
        farewell: 'Good doing business with you!',
        buybackSlots: 24,
        repairEnabled: false,
        inventory: [
            // This vendor primarily buys materials from players
            { itemId: 'slime_goo', stock: 50, buyPrice: 5, sellMultiplier: 0.5 },
            { itemId: 'slime_core', stock: 20, buyPrice: 30, sellMultiplier: 0.5 },
            { itemId: 'spider_silk', stock: 30, buyPrice: 8, sellMultiplier: 0.5 },
            { itemId: 'spider_fang', stock: 15, buyPrice: 20, sellMultiplier: 0.5 },
            { itemId: 'wolf_pelt', stock: 25, buyPrice: 12, sellMultiplier: 0.5 },
            { itemId: 'wolf_fang', stock: 15, buyPrice: 25, sellMultiplier: 0.5 },
            { itemId: 'bone_fragment', stock: 40, buyPrice: 8, sellMultiplier: 0.5 },
            { itemId: 'leather_scraps', stock: 30, buyPrice: 8, sellMultiplier: 0.5 },
        ],
    },
    // Rare Goods Dealer
    rare_dealer: {
        id: 'rare_dealer',
        name: 'Shady Silks',
        title: 'Rare Acquisitions',
        icon: '🎭',
        greeting: 'Psst... looking for something special?',
        farewell: 'You never saw me...',
        buybackSlots: 6,
        repairEnabled: false,
        inventory: [
            // Rare/special items at premium prices
            { itemId: 'slime_ring', stock: 1, buyPrice: 500 },
            { itemId: 'chieftain_staff', stock: 1, buyPrice: 400 },
        ],
    },
    // Innkeeper
    innkeeper: {
        id: 'innkeeper',
        name: 'Rosie Hearthwood',
        title: 'Innkeeper',
        icon: '🏠',
        greeting: 'Welcome to the Sleeping Dragon Inn! Rest your weary bones.',
        farewell: 'Come back anytime!',
        buybackSlots: 6,
        repairEnabled: false,
        inventory: [
            { itemId: 'health_potion', stock: -1, buyPrice: 12 },
            { itemId: 'mana_potion', stock: -1, buyPrice: 12 },
            { itemId: 'raw_meat', stock: 20, buyPrice: 5 },
        ],
    },
};
// Get vendors by type
export function getVendorsByType(hasRepair) {
    return Object.values(VENDORS).filter(v => v.repairEnabled === hasRepair);
}
// Check if vendor sells a specific item
export function vendorSellsItem(vendorId, itemId) {
    const vendor = VENDORS[vendorId];
    if (!vendor)
        return false;
    return vendor.inventory.some(item => item.itemId === itemId);
}
// Get item price from vendor
export function getVendorItemPrice(vendorId, itemId) {
    const vendor = VENDORS[vendorId];
    if (!vendor)
        return null;
    const item = vendor.inventory.find(i => i.itemId === itemId);
    return item ? item.buyPrice : null;
}
//# sourceMappingURL=vendors.js.map